import React from 'react';
import AdminCRUD from './AdminCRUD';

const AdminLastMinuteDeals = () => {
  const fields = [
    { name: 'destination', label: 'Destination', type: 'text', required: true, placeholder: 'e.g. Dubai' },
    { name: 'title', label: 'Title', type: 'text', required: true, placeholder: 'e.g. 5 Days Dubai Extravaganza', fullWidth: true },
    { name: 'image', label: 'Image URL', type: 'url', required: true, placeholder: 'https://images.unsplash.com/...', fullWidth: true },
    { name: 'price', label: 'Price', type: 'text', required: true, placeholder: 'e.g. ₹45,999' },
    { name: 'originalPrice', label: 'Original Price', type: 'text', required: true, placeholder: 'e.g. ₹65,999' },
    { name: 'discount', label: 'Discount', type: 'text', required: true, placeholder: 'e.g. 30% OFF' },
    { name: 'travelDates', label: 'Travel Dates', type: 'text', required: true, placeholder: 'e.g. 15 Jan - 20 Jan 2025' },
    { name: 'limitedSeats', label: 'Limited Seats', type: 'text', placeholder: 'e.g. Only 8 seats left' },
    { name: 'includes', label: 'Includes', type: 'textarea', required: true, placeholder: 'e.g. Flights + 4★ Hotel + Breakfast + City Tour', fullWidth: true },
    { name: 'active', label: 'Status', type: 'boolean', checkboxLabel: 'Active', default: true },
  ];

  const columns = [
    { 
      key: 'image', 
      label: 'Image',
      render: (url) => <img src={url} alt="" className="table-thumb" />
    },
    { key: 'destination', label: 'Destination' },
    { key: 'title', label: 'Title' },
    { key: 'price', label: 'Price' },
    { 
      key: 'discount', 
      label: 'Discount',
      render: (discount) => <span className="discount-badge">{discount}</span>
    },
    { 
      key: 'active', 
      label: 'Status',
      render: (active) => <span className={`status-badge ${active ? 'active' : 'inactive'}`}>{active ? 'Active' : 'Inactive'}</span>
    },
  ];

  return (
    <AdminCRUD
      title="Last Minute Deals"
      endpoint="last-minute-deals"
      fields={fields}
      columns={columns}
      renderPreview={true}
    />
  );
};

export default AdminLastMinuteDeals;
